import React from "react";

import SrrRowBase from "./SrrRowBase";

const ReportNSByClientCarSale = ({ row, items }) => {
  const renderItem = [
    row.dealer.DealerName,
    row.dealer.city,
    row.dealer.INN,
    row.dealer.ent_id,
    row.dealer.entfCode,
    row.dealer.subject,
    row.dealer.FO,
    row.dealer.status === "active" ? "1" : "0",
    row.carsOnEPlatform,
    row.clientsLada,
    row.percentCarsOnEPlatform,
  ];

  return <SrrRowBase cells={renderItem} />;
};

export default ReportNSByClientCarSale;
